/* Skapad av Claude Code — LOKAL bundle-state + uppskjuten varukorg för svd-lp-pren-* sections */

(function() {
  'use strict';

  // Sektionerna (tracker + grid + summary) inkluderar denna fil var för sig.
  // Guarden ser till att modulen bara initieras en gång.
  if (window.SvdLpPren) { return; }

  // Paketet byggs LOKALT i minnet. Inget rör Shopify-varukorgen förrän commit()
  // (summary-knappen "Till varukorgen"). Då läggs allt till i ett svep.
  var state = {
    lines: [],            // [{ pid, variantId, quantity, sellingPlanId|null, isOneTime, priceNow, priceWas, title, gwpVariantId|null }]
    unlockedFreebies: [], // [variantId] — milstolpe-produkter som låsts upp (visuellt, läggs till vid commit)
    totals: { count: 0, subCount: 0, now: 0, was: 0 }
  };

  var productMeta = {};       // pid -> meta (registrering, valfritt)
  var milestones = [];        // [{ threshold, variantId, code, title }]
  var notifiedFreebies = {};  // variantId -> bool (toast bara en gång per upplåsning)

  function emit(name, detail) {
    window.dispatchEvent(new CustomEvent(name, { detail: detail }));
  }

  function showToast(message) {
    var existing = document.querySelector('.svd-lp-pren__toast');
    if (existing) existing.remove();
    var el = document.createElement('div');
    el.className = 'svd-lp-pren__toast';
    el.textContent = message;
    document.body.appendChild(el);
    requestAnimationFrame(function() { el.classList.add('is-visible'); });
    setTimeout(function() {
      el.classList.remove('is-visible');
      setTimeout(function() { el.remove(); }, 250);
    }, 3200);
  }

  function registerProduct(productId, meta) {
    productMeta[String(productId)] = meta || {};
  }

  function registerMilestone(cfg) {
    if (!cfg || !cfg.threshold) return;
    var vid = cfg.variantId ? String(cfg.variantId) : '';
    var th = parseInt(cfg.threshold, 10) || 0;
    var dup = milestones.some(function(m) { return m.variantId === vid && m.threshold === th; });
    if (dup) return;
    // gwp: true = gåvan görs gratis av en motor i SVD Functions via en
    // line-property (default _gwp; pren-sidan använder _prengava mot
    // SVD Pren-gåva-motor) — ingen rabattkod behövs.
    milestones.push({ threshold: th, variantId: vid, code: cfg.code || '', gwp: !!cfg.gwp, gwpProperty: cfg.gwpProperty || '_gwp', title: cfg.title || 'din bonus' });
  }

  function recalcTotals() {
    var now = 0, was = 0, subCount = 0;
    state.lines.forEach(function(l) {
      now += l.priceNow || 0;
      was += (l.priceWas || l.priceNow || 0);
      if (!l.isOneTime) subCount += 1; // bara prenumerationsrader räknas mot milstolparna
    });
    state.totals = { count: state.lines.length, subCount: subCount, now: now, was: was };
  }

  // Visuell upplåsning av milstolpe-produkter (ingen cart förrän commit)
  function syncFreebies() {
    var sub = state.totals.subCount;
    var unlocked = [];
    milestones.forEach(function(m) {
      if (!m.variantId) return; // milstolpe utan produkt = bara progress
      if (sub >= m.threshold) {
        unlocked.push(m.variantId);
        if (!notifiedFreebies[m.variantId]) {
          notifiedFreebies[m.variantId] = true;
          showToast('🎁 Du låste upp ' + m.title + ' gratis!');
        }
      } else {
        notifiedFreebies[m.variantId] = false;
      }
    });
    state.unlockedFreebies = unlocked;
  }

  function findLineIndex(pid) {
    for (var i = 0; i < state.lines.length; i++) {
      if (state.lines[i].pid === pid) return i;
    }
    return -1;
  }

  // Lägg till / uppdatera en rad i paketet — LOKALT, ingen cart.
  // opts: { variantId, quantity, sellingPlanId, isOneTime, priceNow, priceWas, title, meta, gwpVariantId }
  // priceNow/priceWas = radens TOTAL (öre) inkl. kvantitet. meta = läsbar valbeskrivning
  // ("Prenumeration · var 50:e dag") som paket-sheeten visar. gwpVariantId = gratis gåva
  // som följer med raden vid commit (PDP-paritet, t.ex. KONG tennisboll).
  function addLine(pid, opts) {
    pid = String(pid);
    opts = opts || {};
    var isOneTime = !!opts.isOneTime;
    var line = {
      pid: pid,
      variantId: String(opts.variantId || ''),
      quantity: Math.max(1, parseInt(opts.quantity, 10) || 1),
      sellingPlanId: isOneTime ? null : (opts.sellingPlanId || null),
      isOneTime: isOneTime,
      priceNow: opts.priceNow || 0,
      priceWas: opts.priceWas || opts.priceNow || 0,
      title: opts.title || '',
      meta: opts.meta || '',
      gwpVariantId: opts.gwpVariantId ? String(opts.gwpVariantId) : null,
      gwpVariantIds: (opts.gwpVariantIds || []).map(String).filter(Boolean),
      properties: opts.properties || null
    };
    var idx = findLineIndex(pid);
    if (idx > -1) state.lines[idx] = line; else state.lines.push(line);
    recalcTotals();
    syncFreebies();
    emit('svd:bundle:update', { state: state });
    return Promise.resolve(state);
  }

  function removeLine(pid) {
    pid = String(pid);
    state.lines = state.lines.filter(function(l) { return l.pid !== pid; });
    recalcTotals();
    syncFreebies();
    emit('svd:bundle:update', { state: state });
    return Promise.resolve(state);
  }

  function isAdded(pid) {
    return findLineIndex(String(pid)) > -1;
  }

  // COMMIT: lägg hela paketet + upplåsta freebies i varukorgen i ETT svep,
  // applicera rabattkoder, och vänta in allt innan löftet resolvar (så summary
  // kan navigera vidare med rabatt-cookies satta).
  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function(r) {
      if (r.ok) return r.json();
      // Plocka ut Shopifys riktiga felbeskrivning
      return r.json().catch(function() { return {}; }).then(function(err) {
        throw new Error(err.description || err.message || ('cart_add_failed_' + r.status));
      });
    });
  }

  // Lägger rader EN OCH EN och returnerar titlarna som inte gick igenom.
  // Används bara i felvägen: /cart/add.js är atomiskt, så ETT slutsålt id gjorde
  // förut att hela paketet föll bort (verifierat 2026-09-15: 422 → noll rader).
  function addItemsOneByOne(items, titles) {
    var failed = [];
    return items.reduce(function(chain, it, idx) {
      return chain.then(function() {
        return addItems([it]).catch(function() {
          failed.push(titles[idx] || 'En vara');
        });
      });
    }, Promise.resolve()).then(function() { return failed; });
  }

  function commit() {
    // Kundens valda produkter (+ ev. gratis gåvor per rad, spegel av PDP:ns GWP).
    // mainTitles håller samma index som mainItems så felvägen kan namnge varan.
    var mainItems = [];
    var mainTitles = [];
    var seenGifts = [];      // variant-id:n — samma gåva läggs aldrig två gånger
    var hasStackGift = false; // en rad bidrog med en HEL gåvostack (≥2 gåvor)
    state.lines.forEach(function(l) {
      if (!l.variantId) return;
      var it = { id: parseInt(l.variantId, 10), quantity: l.quantity || 1 };
      if (!l.isOneTime && l.sellingPlanId) it.selling_plan = parseInt(l.sellingPlanId, 10);
      if (l.properties) it.properties = l.properties;
      mainItems.push(it);
      mainTitles.push(l.title || 'En vara');

      var giftIds = (l.gwpVariantIds && l.gwpVariantIds.length)
        ? l.gwpVariantIds
        : (l.gwpVariantId ? [l.gwpVariantId] : []);
      // Fler än en gåva = GSO-stacken, som alltid innehåller nötchips. Då hoppas
      // sidans egen pren-gåva över nedan, annars får kunden nötchips två gånger
      // (stackens Njord-variant + pren-gåvans "på köpet"-SKU är olika id:n).
      if (giftIds.length > 1) hasStackGift = true;
      giftIds.forEach(function(gv) {
        var gid = parseInt(gv, 10);
        if (!(gid > 0) || seenGifts.indexOf(gid) > -1) return;
        seenGifts.push(gid);
        mainItems.push({ id: gid, quantity: 1, properties: { '_gwp': 'true' } });
        mainTitles.push('Gåvan till ' + (l.title || 'ditt paket'));
      });
    });

    // Bonusar: läggs BARA om milstolpen kan göras gratis — via rabattkod ELLER
    // gwp-motorn (line-propertyn _gwp + regel i SVD Functions). Läggs separat &
    // best-effort → en slut/ogiltig bonus blockerar aldrig köpet.
    var freebieItems = [];
    var codes = [];
    state.unlockedFreebies.forEach(function(vid) {
      if (hasStackGift) return;                                  // GSO-gåvorna vinner
      if (seenGifts.indexOf(parseInt(vid, 10)) > -1) return;     // redan tillagd
      var m = milestones.find(function(mm) { return mm.variantId === vid; });
      if (m && m.gwp) {
        var props = {};
        props[m.gwpProperty || '_gwp'] = 'true';
        freebieItems.push({ id: parseInt(vid, 10), quantity: 1, properties: props });
      } else if (m && m.code) {
        freebieItems.push({ id: parseInt(vid, 10), quantity: 1 });
        if (codes.indexOf(m.code) === -1) codes.push(m.code);
      }
    });

    if (!mainItems.length) return Promise.resolve(null);

    return addItems(mainItems)
      .catch(function() {
        // Något tog slut mellan sidladdning och klick — lägg resten ändå.
        return addItemsOneByOne(mainItems, mainTitles).then(function(failed) {
          if (failed.length === mainItems.length) {
            throw new Error('Inget kunde läggas till i varukorgen — försök igen');
          }
          if (failed.length) {
            emit('svd:bundle:partial', { failed: failed });
            showToast(failed.join(', ') + ' hann ta slut och kunde inte läggas till. Resten ligger i varukorgen.');
          }
        });
      })
      .then(function() {
        if (!freebieItems.length) return null;
        return addItems(freebieItems).catch(function(e) {
          console.warn('[svd-lp-pren] bonus kunde inte läggas till:', e && e.message);
        });
      })
      .then(function() {
        // Sätt kombinerbara rabattkoder (cookie) innan vidare-navigering
        return Promise.all(codes.map(function(code) {
          return fetch('/discount/' + encodeURIComponent(code), { method: 'GET' }).catch(function() {});
        }));
      })
      .catch(function(err) {
        console.error('[svd-lp-pren] kunde inte lägga i varukorgen:', err && err.message);
        emit('svd:bundle:error', { message: err.message });
        showToast(err.message || 'Kunde inte lägga till i varukorgen — försök igen');
        throw err;
      });
  }

  window.SvdLpPren = {
    state: state,
    registerProduct: registerProduct,
    registerMilestone: registerMilestone,
    getMilestones: function() { return milestones.slice(); },
    getState: function() { return state; },
    isAdded: isAdded,
    addLine: addLine,
    removeLine: removeLine,
    commit: commit
  };

  // Initialt tomt paket → låt sektionerna rendera nolläge
  function init() {
    recalcTotals();
    syncFreebies();
    emit('svd:bundle:update', { state: state });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(init, 0); });
  } else {
    setTimeout(init, 0);
  }
})();
